import * as React from "react";

import Spinner from "@src/lib/ui/Spinner";
import { cn } from "@src/lib/utils/cn";

type EmptyStateProps = React.HTMLAttributes<HTMLDivElement> & {
  loading?: boolean;
};

const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ loading = false, className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "flex flex-1 flex-col items-center justify-center self-stretch px-6 py-20",
          className,
        )}
        {...props}
      >
        {loading ? <Spinner /> : children}
      </div>
    );
  },
);
EmptyState.displayName = "EmptyState";

const EmptyStateIcon = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      "flex size-16 items-center justify-center text-gray-5",
      className,
    )}
    {...props}
  />
));
EmptyStateIcon.displayName = "EmptyStateIcon";

const EmptyStateTitle = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "mt-2 text-center text-sm font-medium text-gray-7",
      className,
    )}
    {...props}
  />
));
EmptyStateTitle.displayName = "EmptyStateTitle";

const EmptyStateDescription = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "mt-1 max-w-prose text-balance text-center text-sm font-medium text-gray-5",
      className,
    )}
    {...props}
  />
));
EmptyStateDescription.displayName = "EmptyStateDescription";

export { EmptyState, EmptyStateIcon, EmptyStateTitle, EmptyStateDescription };
